<template>
  <header class="header d-flex flex-wrap justify-content-center py-3 border-bottom">
    <router-link class="left-corner" to="/admin/login"></router-link>
    <div class="col-4 float-left">
      <a href="/" class="logo">
        <img src="/pub/media/spa/assets/img/ktlogo.svg"/>
      </a>
    </div>
    <div class="col-8">
      <ul class="nav nav-pills float-right" v-if="!isCustomer">
        <li class="nav-item"><router-link class="nav-link" to="/" v-if="!user">Inicio</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/login" v-if="!user">Iniciar sesión</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/" v-if="user">Dashboard</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/logout" v-if="user">Logout</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/profile" v-if="user">{{ user }}</router-link></li>
      </ul>
    </div>
  </header>
</template>

<script>
import auth from "@/store/authentication.js";

const user_role = auth.state.user_role;

export default {
  name: 'Header',
  props: {
    msg: String
  },
  data: function () {
    return {
      user: null,
      customers: ["customer"],
      partners: ["partner"],
      admins: ["admin"],
      adminsOrPartners: ["admin", "partner"],
    }
  },
  mounted() {
    this.user = auth.state.user;
    console.log(this.user);
  },
  computed: {
    isCustomer() {
      return this.$data.customers.includes(user_role);
    },
    isPartner() {
      return this.$data.partners.includes(user_role);
    },
    isAdmin() {
      return this.$data.admins.includes(user_role);
    },
    isAdminOrPartner() {
      return this.$data.adminsOrPartners.includes(user_role);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Header.vue